const imp = () => import(/* webpackChunkName: "loadSprite_form_advanced_controls"*/  "../sprite/loadSprite_form_advanced_controls");
const loadMap_form_advanced_controls: { [key: string]: () => Promise<any> } = {
  "Icon-Arithmetic-control": imp,
  "Icon-Associate-contact": imp,
  "Icon-Associated-ID-card": imp,
  "Icon-Associated-abnormal-attendance": imp,
  "Icon-Associated-documents": imp,
  "Icon-Associated-form": imp,
  "Icon-Associated-items": imp,
  "Icon-Associated-order": imp,
  "Icon-Associated-schedule": imp,
  "Icon-Associated-tasks": imp,
  "Icon-Associated-quotation": imp,
  "Icon-Button-control": imp,
  "Icon-Collapse-control": imp,
  "Icon-Date-range": imp,
  "Icon-Department-selection": imp,
  "Icon-Descriptive-text": imp,
  "Icon-Digital-input-box": imp,
  "Icon-Electronic-invoice": imp,
  "Icon-Linked-reports": imp,
  "Icon-Dividing-line": imp,
  "Icon-Multi-level-drop-down": imp,
  "Icon-Multiline-text": imp,
  "Icon-Multiple-choice": imp,
  "Icon-Multiple-choice-of-pictures": imp,
  "Icon-Parts-list": imp,
  "Icon-Picture-control": imp,
  "Icon-Related-approval": imp,
  "Icon-Related-attendance": imp,
  "Icon-Related-business-opportunities": imp,
  "Icon-Related-clues": imp,
  "Icon-Related-competitors": imp,
  "Icon-Related-contract": imp,
  "Icon-Related-customers": imp,
  "Icon-Related-marketing-activities": imp,
  "Icon-Related-performance": imp,
  "Icon-Related-products": imp,
  "Icon-Single-choice": imp,
  "Icon-Single-line-text": imp,
  "Icon-Subtable-control": imp,
  "Icon-Tab-control": imp,
  "Icon-Table-layout": imp,
  "Icon-Telephone-form": imp,
  "Icon-Three-columns-in-one-row": imp,
  "Icon-Tree-control": imp,
  "Icon-Two-columns-in-one-row": imp,
  "Icon-User-selection": imp,
  "Icon-amount-of-money": imp,
  "Icon-Wheel-control": imp,
  "Icon-autograph": imp,
  "Icon-date": imp,
  "Icon-data-source": imp,
  "Icon-drop-down": imp,
  "Icon-enclosure": imp,
  "Icon-geographical-position": imp,
  "Icon-mailbox": imp,
  "Icon-matrix": imp,
  "Icon-mobile-phone": imp,
  "Icon-number": imp,
  "Icon-progress-bar": imp,
  "Icon-score": imp,
  "Icon-time": imp,
  "Icon-Picture-radio-o": imp,
  "Icon-Submission-time-o": imp,
  "Icon-geographical-position-o": imp,
}
export default loadMap_form_advanced_controls;